import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Locations/hooks/useInfoBlocksForLocationCategory.ts
function useInfoBlocksForLocationCategory(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetInfoBlocksForLocationCategory.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!(args?.locationId && args?.infoBlockCategoryId)
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useInfoBlocksForLocationCategory };

//# sourceMappingURL=useInfoBlocksForLocationCategory.js.map